import { io } from 'socket.io-client';
import api from './api';

const realtimeUrl = process.env.REACT_APP_REPORTS_REALTIME_URL?.trim();
const usaProxy = api.defaults.baseURL.startsWith('/reportes-api');

export const conectarNotificaciones = () => io(
  realtimeUrl || (usaProxy ? window.location.origin : new URL(api.defaults.baseURL, window.location.origin).origin),
  {
    path: !realtimeUrl && usaProxy ? '/reportes-realtime/socket.io' : '/socket.io',
    auth: callback => callback({
      token: localStorage.getItem('token'),
      email: localStorage.getItem('userEmail'),
    }),
  }
);
